import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import { updatePsd } from '@/api/admin';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    ErrorLog: ErrorLog
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'name'])),
  data: function data() {
    return {
      userData: {},
      form: {
        old_password: null,
        new_password: null,
        password_again: null
      },
      isVisible: false,
      btnLoading: false,
      rules: {
        old_password: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }],
        new_password: [{
          required: true,
          min: 8,
          max: 18,
          message: '请正确的输入新密码',
          trigger: 'blur'
        }],
        password_again: [{
          required: true,
          min: 8,
          max: 18,
          message: '请正确的输入确认密码',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.userData = this.$store.state.user.userData || {};
    console.log(this.userData, "this.userData");
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    onClose: function onClose() {
      this.isVisible = false;
      this.$refs.form.resetFields();
    },
    onSubmit: function onSubmit() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.btnLoading = true;
          updatePsd(_objectSpread({}, _this.form)).then(function (res) {
            _this.btnLoading = false;
            if (res.data.success) {
              _this.$notify({
                title: '提示',
                message: '修改成功',
                type: 'success'
              });
              _this.onClose();
              _this.$store.dispatch('user/logout');
              _this.$router.push("/login?redirect=".concat(_this.$route.fullPath));
            } else {
              _this.$notify.error({
                title: '错误',
                message: res.data.message || '修改失败'
              });
            }
          }).catch(function (e) {
            _this.btnLoading = false;
          }).finally(function () {
            _this.btnLoading = false;
          });
        } else {
          return false;
        }
      });
    }
  }
};